<template>
  <q-page class="column" v-if="this.noteTemplate">
    <q-toolbar class="bg-secondary text-white">
      <q-btn flat dense icon="mail" />
      <q-btn flat dense icon="alarm" disabled/>
      <!--<q-btn flat dense :icon="'border_' + layoutOrientation" @click="switchOrientation"/>-->
      <!--<q-btn flat dense icon="settings" @click="showEditorSettings"/>-->

      <q-input dark
               color="secondary"
               v-model="noteTemplate.name" :style="{'font-size': '6mm', width: '25%'}"
               @input="titleChanged"></q-input>
      <q-toolbar-title>
      </q-toolbar-title>

      <q-btn-group>
        <q-btn v-for="split in Object.values(splits)" :key="split.index"
               :color="split.visible ? (split.locked ? 'black' : 'white') : 'secondary'"
               :text-color="split.visible ? 'secondary' : 'white'"
               :icon="split.icon"
               @click="clickSetSplit(split)" />
      </q-btn-group>
      <q-btn-dropdown color="secondary" :label="maxEditors" small class="q-ml-sm">
        <q-list link>
          <q-item v-for="n in 6" :key="`1.${n}`" v-close-popup @click.native="maxEditors = n; closeExtraSplits(); recreateSplits()">
            <q-item-main>
              <q-item-label>{{n}}</q-item-label>
            </q-item-main>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </q-toolbar>

    <div class="row no-wrap overflow-hidden col">
      <div v-for="(editorInfo, editor) in splits" v-if="editor !== 'scripts'" :key="editor"
           :id="'cm' + editor + 'div'" v-show="editorInfo.visible" class="column">
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title>
            <q-icon :name="editorInfo.icon"/>
            {{editorInfo.name}}
          </q-toolbar-title>
        </q-toolbar>
        <ace-editor :ref="'cm' + editor"
                    :options="cmOpts(editor)"
                    @change="codeChange(editor, ...arguments)"
                    :content="noteTemplate[editor]"
                    class="col">
        </ace-editor>
      </div>
      <div v-for="(editorInfo, editor) in splits" v-if="editor === 'scripts'" :key="editor"
           :id="'cm' + editor + 'div'" v-show="editorInfo.visible" class="column">
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title>
            <q-icon :name="editorInfo.icon"/>
            {{editorInfo.name}}
          </q-toolbar-title>
          <q-select
            v-model="selectedScript"
            dark
            map-options
            emit-value
            dense
            :options="scriptNamesAsOpts"
            :disable="scriptNames.length == 0">
          </q-select>
          <q-btn icon="add" dense flat @click="addNewScript"></q-btn>
          <q-btn icon="mdi-settings" dense flat @click="showScriptSettings = !showScriptSettings"></q-btn>
        </q-toolbar>
        <div v-if="showScriptSettings && ((noteTemplate|| {}).scripts || {})[selectedScript]" class="q-pa-md">
          <q-field
            icon="mdi-format-title"
            label="Script Name">
            <q-input v-model="noteTemplate.scripts[selectedScript].name"></q-input>
          </q-field>
          <q-field
            icon="mdi-earth"
            helper="Local scope will be limited to this note template."
            label="Script Scope">
            <q-option-group
              color="secondary"
              type="radio"
              inline
              v-model="noteTemplate.scripts[selectedScript].isGlobal"
              :options="[
                { label: 'Local', value: false },
                { label: 'Global', value: true }
              ]">
            </q-option-group>
          </q-field>
          <q-btn color="red" icon="delete" flat @click="deleteScript">Delete</q-btn>
          <!--<q-field-->
            <!--icon="cloud"-->
            <!--label="Choose Script Type">-->
            <!--<q-option-group-->
              <!--color="secondary"-->
              <!--type="radio"-->
              <!--v-model="noteTemplate.scripts[selectedScript].type"-->
              <!--:options="[-->
                <!--{ label: 'Javascript', value: 'js' },-->
                <!--{ label: 'CSS', value: 'css' }-->
              <!--]">-->
            <!--</q-option-group>-->
          <!--</q-field>-->
        </div>
        <ace-editor v-if="((noteTemplate|| {}).scripts || {})[selectedScript]"
                    :ref="'cm' + editor"
                    :options="cmOpts(editor)"
                    @change="codeChange(editor, ...arguments)"
                    :content="noteTemplate.scripts[selectedScript].content"
                    :sync="true"
                    class="col">
        </ace-editor>
        <div v-if="!(((noteTemplate|| {}).scripts || {})[selectedScript])">
          Add a script to get started
          <q-btn @click="addNewScript">Add a Script</q-btn>
        </div>
      </div>
    </div>
    <compare-modal ref="compareModal"></compare-modal>
  </q-page>
</template>

<script>
import CompareObjectsModal from '../components/CompareObjectsModal'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-html'
import '../js/ace/mode-custom_js'
import 'ace-builds/src-noconflict/theme-monokai'
import Split from 'split.js'
import Vue from 'vue'

export default {
  data () {
    return {
      layoutOrientation: 'horizontal',
      splits: {
        template: { visible: true, index: 0, icon: 'fab fa-js', locked: false, name: 'Template' },
        scripts: { visible: true, index: 1, icon: 'mdi-script', locked: false, name: 'Scripts' },
        desc: { visible: false, index: 2, icon: 'fas fa-code', locked: false, name: 'Description' }
      },
      splitter: null,
      item: {
        id: '00000000000000',
        data: ''
      },
      noteTemplate: null,
      maxEditors: 2,
      renderedCache: '',
      curCmp: null,
      renderedMd: null,
      componentDefinitionAry: [],
      selectedScript: null,
      showScriptSettings: false
    }
  },
  components: {
    'compare-modal': CompareObjectsModal
  },
  computed: {
    noteTemplateInStore () {
      if (this.noteTemplate == null) return null
      return this.$store.state.noteTemplates.noteTemplates[this.$route.params.id]
    },
    defaultEditorSettings () {
      let editorSettings = this.$store.state.auth.currentUser.settings.editor
      let defaultOpts = {
        navigateWithinSoftTabs: true,
        animatedScroll: true,
        showInvisibles: false, // TODO: add setting
        printMargin: false,
        fontSize: '10px',
        // fontFamily: '',
        // scrollPastEnd: 0.5,
        // theme: 'ace/theme/',
        overwrite: false, // TODO: add setting
        newLineMode: 'auto', // "auto" | "unix" | "windows"
        useSoftTabs: true,
        // useWorker: true,
        tabSize: 2,
        wrap: 'free',
        theme: 'default',
        foldStyle: 'markbegin' // "markbegin"|"markbeginend"|"manual"
      }
      if (this.$store.state.auth.currentUser == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings.editor == null) return defaultOpts
      return Object.assign(defaultOpts, editorSettings)
    },
    scripts () {
      return this.noteTemplate.scripts || []
    },
    scriptNames () {
      return this.$_.map(this.scripts, o => o.name)
    },
    scriptNamesAsOpts () {
      return this.$_.map(this.scripts, (o, i) => { return { label: o.name, value: i } })
    }
  },
  watch: {
    noteTemplateInStore (newVal) {
      if (this.$_.isEqual(this.noteTemplate, newVal)) return
      console.log('NoteTemplate in store changed!!!!')
      // TODO: add a comparison, show the user what has changed!!
      this.showCompareModal(this.noteTemplate, newVal).then(() => {
        this.pullLocalNoteTemplateFromStore(this.noteTemplate.id)
      }).catch((err) => {
        console.log('Local version kept, remote version ignored: ' + err)
      })
    },
    'noteTemplate.description' (newVal) {
      this.noteTemplate.description = newVal
    },
    'noteTemplate.template' (newVal) {
      this.noteTemplate.template = newVal
    }
    // TODO: scripts
  },
  methods: {
    deleteScript () {
      let script = (this.noteTemplate.scripts || {})[this.selectedScript]
      if (!(script)) return
      this.$q.dialog({
        title: 'Delete Script?',
        message: 'Are you sure you want to delete this script: ' + script.name + '?',
        ok: 'Yes',
        cancel: 'Cancel'
      }).then(() => {
        this.noteTemplate.scripts.splice(this.selectedScript, 1)
        this.selectedScript = 0
      }).catch(() => {
        // just catch it so we don't get an error logged
      })
    },
    addNewScript () {
      if (!this.noteTemplate.scripts) Vue.set(this.noteTemplate, 'scripts', [])
      let newScript = {
        isGlobal: false,
        name: 'New Script ' + (this.noteTemplate.scripts.length + 1),
        type: 'js',
        content: '/* new script */'
      }
      this.selectedScript = this.noteTemplate.scripts.push(newScript) - 1
    },
    sortByKeys (unordered) {
      const ordered = {}
      Object.keys(unordered).sort().forEach(key => {
        ordered[key] = unordered[key]
      })
      return ordered
    },
    showCompareModal (local, remote) {
      return this.$refs['compareModal'].show(
        JSON.stringify(this.sortByKeys(local), null, 2).replaceAll('\\\\n', '\n'),
        JSON.stringify(this.sortByKeys(remote), null, 2).replaceAll('\\\\n', '\n'))
      // return this.$refs['compareModal'].show(local.data, remote.data)
    },
    cmOpts (editor) {
      let editorSettings = Object.assign({}, this.defaultEditorSettings)
      switch (editor) {
        case 'template':
          editorSettings.mode = 'custom_js'
          break
        case 'scripts':
          editorSettings.mode = 'custom_js'
          break
        case 'description':
          editorSettings.mode = 'markdown'
          break
      }
      return editorSettings
    },
    saveNow () {
      // Clear any pending saves
      clearTimeout(this.saveTimeout)
      this.saveTimeout = null
      // Check item exists
      if (this.noteTemplate == null) {
        console.log('Could not save noteTemplate ' + this.$route.params.id)
        return Promise.all([])
      }
      // Check that there are changes to save
      if (!this.unsavedChanges) {
        return Promise.all([])
      }
      console.log('Saving noteTemplate ' + this.noteTemplate.id)
      this.noteTemplate.updatedAt = new Date()
      return this.$store.dispatch('updateNoteTemplate', this.noteTemplate)
    },
    /**
     * Save with a timeout
     * @param saveDelayMs ms to delay before saving
     */
    saveThrottled (saveDelayMs) {
      this.unsavedChanges = true
      clearTimeout(this.saveTimeout) // Reset timer (ie. delay save to 1s from now instead of whatever the timeout value was)
      this.saveTimeout = setTimeout(() => {
        this.saveNow()
      }, saveDelayMs || 1000)
    },
    codeChange (editor, newVal) {
      if (editor === 'scripts') {
        if (this.noteTemplate[editor][this.selectedScript].content === newVal) return
        this.noteTemplate[editor][this.selectedScript].content = newVal
      } else {
        if (this.noteTemplate[editor] === newVal) return
        this.noteTemplate[editor] = newVal
      }
      this.saveThrottled()
    },
    switchOrientation () {
      // TODO: not working!
      if (this.layoutOrientation === 'horizontal') {
        this.layoutOrientation = 'vertical'
      } else {
        this.layoutOrientation = 'horizontal'
      }
      this.recreateSplits()
    },
    checkZeroWidthSplits () {
      let needsUpdate = false
      let sizes = this.splitter.getSizes()
      let openSplits = this.$_.sortBy(this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? v : null }), null), 'index')
      sizes.forEach((s, i) => {
        if (s < 1) {
          openSplits[i].visible = false
          needsUpdate = true
        }
      })
      if (needsUpdate) this.recreateSplits()
    },
    refreshVisibleEditors () {
      this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? 'cm' + k : null }), null).forEach(en => {
        if (en === 'cmpreview') return
        if (!this.$refs[en]) return
        this.$refs[en][0].editor.resize(true)
      })
    },
    recreateSplits (preserveWidths) {
      let selectors = this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? '#cm' + k + 'div' : null }), null)
      let widths = null

      if (preserveWidths && this.splitter) {
        widths = this.splitter.getSizes()
      }

      if (this.splitter) {
        this.splitter.destroy()
      }

      let t = this
      this.splitter = Split(selectors, {
        sizes: widths,
        minSize: 0,
        gutterSize: 8,
        direction: this.layoutOrientation,
        onDragEnd: function () {
          // localStorage.setItem('split-sizes', JSON.stringify(split.getSizes()));
          t.checkZeroWidthSplits()
          t.refreshVisibleEditors()
        }
      })
      this.$nextTick(() => {
        t.refreshVisibleEditors()
      })
    },
    visibleSplits () {
      return this.$_.countBy(this.splits, 'visible')[true]
    },
    visibleUnlockedSplits () {
      return this.$_.pickBy(this.splits, s => s.visible && !s.locked)
    },
    closeExtraSplits (aboutToOpen) {
      while (this.visibleSplits() + (aboutToOpen ? 1 : 0) > this.maxEditors) { // eslint-disable-line no-unmodified-loop-condition
        this.splits[Object.keys(this.visibleUnlockedSplits())[0]].visible = false
        // this.splits[this.$_.findKey(this.splits, ['visible', true])].visible = false
      }
    },
    clickSetSplit (split) {
      if (!split.visible) {
        if (Object.keys(this.visibleUnlockedSplits()).length + 1 <= this.maxEditors) {
          this.setSplitVisible(split, 'true')
        }
      } else if (split.visible && !split.locked) {
        split.locked = true
      } else {
        split.locked = false
        this.setSplitVisible(split, false)
      }
    },
    setSplitVisible (split, visible) {
      if (visible === 'toggle') visible = !split.visible
      let preserveWidths = false
      let openSplits = this.visibleSplits()
      // Not allowed to turn all splits off.  Must keep at least one!
      if (openSplits === 1 && !visible) return
      this.closeExtraSplits(visible)
      split.visible = visible
      if (this.visibleSplits() === openSplits) preserveWidths = true // Same number of splits?
      this.recreateSplits(preserveWidths)
    },
    titleChanged (newVal) {
      this.noteTemplate.name = newVal.trim()
      this.saveThrottled()
    },
    updateArgHints (editor, cm) {
      // this.ternServer.updateArgHints(cm)
    },
    // TODO: Maybe this isn't so useful in JS?  Add an option to turn it on/off?
    // TODO: Add this functionality to main page markdown render!!!
    // TODO: Automatically replace all tabs in all docs with spaces!!!!!!
    cmWrapLineOnRender (editor, cm, line, elt) {
      // let basePadding = 4
      // let charWidth = cm.defaultCharWidth()
      // let off = CodeMirror.countColumn(line.text, null, cm.getOption('tabSize')) * charWidth
      // let equalsIndex = line.text.indexOf('=')
      // if (equalsIndex > -1) {
      //   off = ((equalsIndex + 2) * charWidth)
      // }
      // elt.style.textIndent = '-' + off + 'px'
      // elt.style.paddingLeft = (basePadding + off) + 'px'
    },
    pullLocalNoteTemplateFromStore (noteTemplateId) {
      this.noteTemplate = this.$_.cloneDeep(this.$store.state.noteTemplates.noteTemplates[noteTemplateId])
      if (this.noteTemplate == null) this.$router.replace('/noteTemplates')
      // this.item.data = this.noteTemplate.code.desc
      this.unsavedChanges = false
      this.selectedScript = 0
      // resetCustomMd()
      this.$nextTick(() => {
        this.recreateSplits(true)
      })
    }
  },
  mounted () {
    // this.ternServer = new CodeMirror.TernServer({defs: [this.$_.cloneDeep(componentJsTernDefs)]})
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.pullLocalNoteTemplateFromStore(vm.$route.params.id)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.saveNow().then(() => {
      next()
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.saveNow().then(() => {
      this.pullLocalNoteTemplateFromStore(to.params.id)
      next()
    })
  }
}
</script>

<style lang="styl">
  .render-container {
    h1:first-child {
      font-size: 40px;
      margin-bottom: 20px;
    }
  }

  .vue-codemirror {
    height: 100%;
  }

  .CodeMirror {
    height: 100%;
    wisth: 100%;
    /*height: 500px;*/
    /*width: 800px;*/

  }

  .split-horizontal {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .split-vertical {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .gutter {
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: 50%;
  }

  .gutter.gutter-horizontal {
    cursor: col-resize;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');
  }

  .gutter.gutter-vertical {
    cursor: row-resize;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
  }

  .split.split-horizontal, .gutter.gutter-horizontal {
    /*height: 300px;*/
    float: left;
  }
</style>
